import { render, staticRenderFns } from "./EstimatedFullCardBarLabel.vue?vue&type=template&id=231cada2"
import script from "./EstimatedFullCardBarLabel.vue?vue&type=script&lang=js"
export * from "./EstimatedFullCardBarLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports